import AboutGuide from "../../Components/AboutGuide";
import styles from "../../Styles/Homepage.module.scss";
import { useParams } from "react-router-dom";

function Homepage() {
  const params = useParams();

  let dates = "";
  let title = "";
  let description = "";

  switch (params.trip) {
    case "September-2026":
      dates = "September 29 - October 13, 2026";
      title = "Israel & Petra";
      description =
        "This comprehensive trip to Israel will take you from Mount Hermon in the far north to the Red Sea in the far south. It also includes an exciting day trip to Petra in Jordan. This is truly the cadillac of Holy Land tours.";
      break;
    case "October-2026":
      dates = "October 20 - 30, 2026";
      title = " Israel";
      description = "";
      break;
    case "November-2026":
      dates = "November 2 - 16, 2026";
      title = "Israel & Petra";
      description =
        "This comprehensive trip to Israel will take you from Mount Hermon in the far north to the Red Sea in the far south. It also includes an exciting day trip to Petra in Jordan. This is truly the cadillac of Holy Land tours.";
      break;
    case "June-2027":
      dates = "May 24 - June 4, 2027";
      title = " Israel";
      description = "";
      break;
    case "trip":
      dates = "";
      title = "Israel & Petra";
      description =
        "This comprehensive trip to Israel will take you from Mount Hermon in the far north to the Red Sea in the far south. It also includes an exciting day trip to Petra in Jordan. This is truly the cadillac of Holy Land tours.";

      break;
  }
  return (
    <div className={styles.backgroundPictureIsrael}>
      <div className={styles.titleBox}>
        <h1>Visit the land of the Bible</h1>
        <p className={styles.title}>{title}</p>
        <p className={styles.dates}>{dates}</p>
        <div className={styles.description}>
          <p>{description}</p>
        </div>
        <div>
          <AboutGuide />
        </div>
      </div>
    </div>
  );
}

export default Homepage;
